import React from 'react';
import { Button, DatePicker, Space, Typography } from 'antd';
import dayjs, { Dayjs } from 'dayjs';
import moment, { Moment } from 'moment';
import {
    FileExcelOutlined
  } from "@ant-design/icons";
import { DashboardService } from '../../services/DashboardService';
const { Text } = Typography;

interface Props {
    setFilters: (data: Object) => void;
}

const Filter = (props: Props) => {

    const [month, setMonth] = React.useState(moment().format('MM'))
    const [year, setYear] = React.useState(moment().format('YYYY'))

    React.useEffect(() => {
        props.setFilters({
            // month: moment().format('MM'),
            // year: moment().format('YYYY')
        });
    }, [])

    const handleDateChange = (date: Dayjs) => {

        const m = date.format('MM')
        const y = date.format('YYYY')
        setMonth(m)
        setYear(y)
        
        props.setFilters({
            month: date && m || null,
            year: date && y || null,
        });

      
    };

    const exportTransaction = async() => {
        await DashboardService.exportTransaction({
            month: month,
            year: year,
        });
    }

    return (
        <Space direction="vertical" size={12}>

            <div>

                <Text>Select Year-Month : </Text>
                <DatePicker

                    style={{
                        width: 180
                    }}
                    defaultValue={null}
                    format={'YYYY-MM'}
                    onChange={handleDateChange}
                    allowClear={true}
                    picker="month"
                    placeholder="Select Year-Month"
                />
                &nbsp;
                <Button type='default' onClick={() => exportTransaction()} style={{ padding:0}}>&nbsp;<FileExcelOutlined style={{fontSize:16}}></FileExcelOutlined></Button>
            </div>
        </Space>
    )
}

export default Filter